import { fetchResource } from "../helpers/network";

import {
  setErrorNotification,
  setSuccessNotification
} from "../actions/notifications";

export const REQUEST_COST_LIMITS = "REQUEST_COST_LIMITS";
export const RECEIVE_COST_LIMITS = "RECEIVE_COST_LIMITS";
export const EDIT_COST_LIMIT = "EDIT_COST_LIMIT";
export const CANCEL_EDIT_COST_LIMIT = "CANCEL_EDIT_COST_LIMIT";
export const PATCH_EDIT_COST_LIMIT = "PATCH_EDIT_COST_LIMIT";

export const requestCostLimits = () => ({ type: REQUEST_COST_LIMITS });

export const receiveCostLimits = costLimits => ({
  type: RECEIVE_COST_LIMITS,
  costLimits: costLimits.data
});

export function fetchCostLimits(params) {
  const paramsWithPath = { ...params, path: "/costlimits" };
  return function(dispatch, getState) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        requestCostLimits,
        receiveCostLimits,
        setErrorNotification
      )
    );
  };
}

export const cancelEditCostLimit = () => ({
  type: CANCEL_EDIT_COST_LIMIT
});

export const patchEditCostLimit = patch => ({
  type: PATCH_EDIT_COST_LIMIT,
  patch
});

export const editCostLimit = id => {
  return function(dispatch, getState) {
    const state = getState();
    const costLimit = { ...state.entities.costLimits[id] };
    return dispatch({
      type: EDIT_COST_LIMIT,
      id: costLimit.id,
      isRecurring: costLimit.recurring === true
    });
  };
};

const dateStringToMicroSeconds = dateString =>
  new Date(`${dateString} 00:00:00`).getTime() * 1000;

export function putCostLimit(id, params) {
  const paramsWithPath = Object.assign({}, params, {
    method: "PUT",
    path: `/costlimits/${id}`
  });
  paramsWithPath.body.startDate = dateStringToMicroSeconds(
    paramsWithPath.body.startDate
  );
  paramsWithPath.body.endDate = dateStringToMicroSeconds(
    paramsWithPath.body.endDate
  );
  return function(dispatch) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        null,
        json => {
          dispatch(setSuccessNotification("Updated cost limit", null));
          return receiveCostLimits(json);
        },
        () => {
          return setErrorNotification;
        }
      )
    );
  };
}

export function saveCostLimitBeingEdited() {
  return function(dispatch, getState) {
    const state = getState();
    const id = state.modalForm.editCostLimit.id;
    const costLimit = state.entities.costLimits[id];
    if (!costLimit) {
      return;
    }
    const recurring = state.modalForm.editCostLimit.isRecurring;
    const patch = {
      recurring,
      ...state.modalForm.editCostLimit
    };
    delete patch.isRecurring;
    const params = {
      body: { ...costLimit, ...patch }
    };
    return dispatch(putCostLimit(id, params));
  };
}



// WEBPACK FOOTER //
// ./src/actions/costLimits.js